/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
// import core & vendor packages below
import axios from 'axios';
import { useSelector } from 'react-redux';
import React, { useState, useEffect } from 'react';

// import Components below
import Filter from './Filter';
import Profile from './Profile';
import ArchiveTable from './Table';
import Status from 'constant/status';
import Tabs from 'constant/medicalRecordTabs';
import { selectAuth } from 'reducers/authReducer';
import FormPatientProfile from '../FormPatientProfile';
import ConditionalRender from 'components/ConditionalRender';
import { checkStringPermission } from 'helpers/filteredPermissions';

// import assets below
import './index.scss';

// Main Component
const Archive = () => {
  const userData = useSelector(selectAuth);
  const { permissions } = userData;

  const [state, setState] = useState([]);
  const [showScreen, setShowScreen] = useState(0);

  const [showProfile, setShowProfile] = useState({
    setActive: '',
    profileId: null,
    isShowView: false,
    isModalShow: false,
  });

  const isDefault = showScreen === 0;
  const isViewProfile = showScreen === 1;
  const isEditProfile = showScreen === 2;

  useEffect(() => {
    console.log('showProfile', showProfile);
  }, [showProfile]);

  useEffect(() => {
    axios
      .get('/patient', {
        params: {
          patient_status: [Status.DISCHARGED],
        },
      })
      .then((response) => {
        setState(response.data.data);
      }, [])
      .catch((err) => {
        console.log('AXIOS ERROR: ', err);
      });
  }, []);

  return (
    <div className='archive'>
      <ConditionalRender
        condition={isDefault}
        renderIf={
          <>
            <Filter state={state} setState={setState} />

            <ArchiveTable
              state={state}
              setState={setState}
              showProfile={showProfile}
              setShowScreen={setShowScreen}
              setShowProfile={setShowProfile}
            />
          </>
        }
      />

      <ConditionalRender
        condition={isViewProfile}
        renderIf={
          <Profile
            showProfile={showProfile}
            setShowProfile={setShowProfile}
            setShowScreen={setShowScreen}
            setState={setState}
          />
        }
      />

      <ConditionalRender
        condition={isEditProfile}
        renderIf={
          <FormPatientProfile
            showProfile={showProfile}
            setShowScreen={setShowScreen}
            setState={setState}
          />
        }
      />
    </div>
  );
};

export default Archive;
